// Thrown from a `routeChangeStart` handler to cancel a Next.js navigation while the
// nav confirmation modal is shown. Next.js rejects the router.push/replace promise with
// this value, so it must be swallowed by callers and ignored by Sentry.
export const NAV_CONFIRMATION_ABORT_MESSAGE =
  'Route change aborted by navigation confirmation modal.';
